(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizon-parallax-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initParallax(root) {
      var banners = root.querySelectorAll('[data-parallax="true"]');

      banners.forEach(function (el) {
        if (el.dataset.parallaxBound) return;
        el.dataset.parallaxBound = 'true';

        var speed = parseFloat(el.dataset.parallaxSpeed || '0.3');
        var layers = el.querySelectorAll('[data-parallax-layer]');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reducedMotion || layers.length === 0) return;

        var ticking = false;

        function update() {
          var rect = el.getBoundingClientRect();
          var vh = window.innerHeight;

          if (rect.bottom < 0 || rect.top > vh) return;

          var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
          var offset = progress * speed * 100;

          layers.forEach(function (layer) {
            layer.style.transform = 'scale(1.15) translateY(' + offset + 'px)';
          });
        }

        function onScroll() {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              update();
              ticking = false;
            });
            ticking = true;
          }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initParallax(document);
      });
    } else {
      initParallax(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initParallax(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
